<template>
  <div class="container" :style="bgColorStyle">
    <!-- 顶部导航按钮 -->
    <PinnedBtnContainer>
      <component
        v-for="navCompObj in pinnedBtnComponentObjs"
        :key="navCompObj.id"
        :is="navCompObj.component"
        v-bind="navCompObj.props"
        @reportEvent="handleReport"
      ></component>
    </PinnedBtnContainer>
    <!-- Banner -->
    <Banner v-if="dataReady" :imgUrl="tplData.pageConfig.headImage"></Banner>
    <!-- 主操作区域 -->
    <Main
      v-if="dataReady"
      :bgImgUrl="tplData.pageConfig.backgroundImage"
      :bgColor="tplData.pageConfig.backgroundColor"
    >
      <FlowComponentContainer
        v-for="compObj in flowComponentObjs"
        :key="compObj.id"
      >
        <component
          :is="compObj.component"
          v-bind="compObj.props"
          :moduleName="moduleName"
          @reportEvent="handleReport"
        ></component>
      </FlowComponentContainer>
    </Main>
    <!-- 固定定位组件 -->
    <component
      v-for="positionObj in positionComponentObjs"
      :key="positionObj.id"
      :is="positionObj.component"
      :moduleName="moduleName"
      v-bind="positionObj.props"
      @reportEvent="handleReport"
    />
    <Alert :show="disabled" noClose="true">
      <div class="errorToast">{{ disableToast }}</div>
    </Alert>
  </div>
</template>
<script>
import Banner from '@/components/templates/common/Banner';
import Main from '../components/Main';
import Alert from '@u/Alert';
import FlowComponentContainer from '@/components/templates/common/FlowComponentContainer';
import PinnedBtnContainer from '@/components/templates/common/PinnedBtnContainer';
import { mapActions, mapMutations, mapState } from 'vuex';
import TokenIn from '@/components/mixins/tokenIn';
import share from '../mixins/share';
import { isRiskError, isAccessError } from '../../helper';
import { isWeixinBrowser, isWxMiniProgram, isHllApp } from '@/utils';

export default {
  components: {
    Banner,
    Main,
    FlowComponentContainer,
    PinnedBtnContainer,
    Alert
  },
  data() {
    return {
      disabled: false,
      disableToast: ''
    };
  },
  props: {
    tplDataProp: Object,
    moduleName: String,
    actCode: String
  },
  mixins: [TokenIn, share],
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      },
      tplData: function(state) {
        return this.tplDataProp || state[this.moduleName].tplData;
      },
      positionComponentObjs: function(state) {
        return state[this.moduleName].positionComponentObjs;
      },
      flowComponentObjs: function(state) {
        return state[this.moduleName].flowComponentObjs;
      },
      pinnedBtnComponentObjs: function(state) {
        return state[this.moduleName].pinnedBtnComponentObjs;
      }
    }),
    ...mapState('global', ['env']),
    dataReady() {
      return this.tplData.pageConfig;
    },
    bgColorStyle() {
      if (
        this.tplData &&
        this.tplData.pageConfig &&
        this.tplData.pageConfig.backgroundColor
      ) {
        return {
          backgroundColor: this.tplData.pageConfig.backgroundColor
        };
      }
      return {};
    }
  },
  watch: {
    tplData: function(newVal, oldVal) {
      if (!oldVal.pageConfig && newVal.pageConfig) {
        this.initShareConfig();
        this.setTitle();
      }
    }
  },
  methods: {
    ...mapActions('app', {
      getActData: function(dispatch, ...props) {
        return dispatch(`${this.moduleName}/getActData`, ...props);
      }
    }),
    ...mapMutations('app', {
      initSetActCode: function(commit, actCode) {
        return commit(`${this.moduleName}/initSetActCode`, actCode);
      }
    }),
    async initPage() {
      try {
        await this.getActData(this.actCode);
      } catch (error) {
        // 命中风控处理
        if (isRiskError(error.ret)) {
          this.$router.replace('/account_error');
          return;
        }
        if (isAccessError(error.msg)) {
          this.$router.replace('/access_error');
          return;
        }
        this.$hll.toast(error && error.msg);
        throw error;
      }
      await this.invitedReport();
    },
    handleReport(data) {
      this.$emit('reportEvent', data);
    },
    initShareConfig() {
      if (isWeixinBrowser() || isWxMiniProgram()) {
        const actData = this.actData;
        this.shareAct({
          title: actData.shareTitle,
          desc: actData.shareContent,
          img: actData.shareUrl
        });
      }
    },
    setTitle() {
      const actName = this.tplData.pageConfig && this.tplData.pageConfig.name;
      if (actName) {
        document.title = actName;
      }
    }
  },
  mounted() {
    this.setTitle();
  },
  async created() {
    if (this.env === 'driver' && !isHllApp()) {
      this.disabled = true;
      this.disableToast = '请前往货拉拉司机版App参与活动哦~~';
    }
    await this.initSetActCode(this.actCode);
    await this.initPage();
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  padding-bottom: 160px;
}
.errorToast {
  height: 431px;
  font-size: 32px;
  color: #000;
  .fc;
}
</style>
